// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compt {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  overflow: auto;
  row-gap: 5px;
  color: var(--app-base);
}
.compt .step {
  display: flex;
  align-items: center;
  max-width: 250px;
}
.compt .circle {
  margin-right: 8px;
  border: 1px solid var(--app-base);
  border-radius: 50%;
  height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 1px;
}
.compt .circle .circle-icon {
  color: var(--app-succ);
  font-size: 20px;
}
.compt .circle.current {
  background-color: var(--app-base);
  color: var(--app-main-strong);
}
.compt .circle.done {
  border-color: var(--app-succ);
}
.compt .hr {
  margin: 0 8px;
  height: 1px;
  min-width: 20px;
  width: 40px;
  background-color: var(--app-base);
}
.compt .hr_piccolo {
  margin: 0 8px 0 0;
  height: 1px;
  min-width: 5px;
  width: 5px;
  background-color: var(--app-base);
}
.compt.compt--main-lg {
  color: var(--app-mid-dark);
  font-weight: 500;
}
.compt.compt--main-lg .circle {
  margin-right: 12px;
  border-color: var(--app-main);
  border-width: 2px;
  height: 36px;
  min-width: 36px;
  color: var(--app-main);
}
.compt.compt--main-lg .circle .circle-icon {
  font-size: 24px;
}
.compt.compt--main-lg .circle.current {
  background-color: var(--app-main);
  color: var(--app-base);
}
.compt.compt--main-lg .circle.done {
  border-color: var(--app-succ);
}
.compt.compt--main-lg .hr {
  margin: 0 12px;
  background-color: var(--app-main);
}`, "",{"version":3,"sources":["webpack://./src/app/components/desktop/steps/steps.component.scss"],"names":[],"mappings":"AAUA;EACC,aAAA;EAEA,uBAAA;EAEA,iBAAA;EACC,cAAA;EACD,YAAA;EAEA,sBAAA;AAZD;AAgBC;EACC,aAAA;EACA,mBAAA;EAEA,gBAAA;AAfF;AAmBC;EACC,iBAAA;EAEA,iCAAA;EACA,kBAAA;EAGA,YAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAGA,eAAA;EACA,gBAAA;EACA,mBAAA;AAvBF;AA0BE;EACC,sBAAA;EACA,eAAA;AAxBH;AA2BE;EACC,iCAAA;EACA,6BAAA;AAzBH;AA4BE;EACC,6BAAA;AA1BH;AAiCC;EACC,aAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,iCAAA;AA/BF;AAkCE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,iCAAA;AAhCJ;AAoCC;EACC,0BAAA;EACA,gBAAA;AAlCF;AAoCE;EACC,kBAAA;EAEA,6BAAA;EACA,iBAAA;EAGA,YAAA;EACA,eAAA;EAEA,sBAAA;AAtCH;AAyCG;EACC,eAAA;AAvCJ;AA0CG;EACC,iCAAA;EACA,sBAAA;AAxCJ;AA2CG;EACC,6BAAA;AAzCJ;AA+CE;EACC,cAAA;EACA,iCAAA;AA7CH","sourcesContent":["\n\n// @import \"../../../../theme/desktop\";\n\n\n\n\n\n\n\n.compt {\n\tdisplay: flex;\n\t// align-items: center;\n\tjustify-content: center;\n\n\tflex-wrap: nowrap;\n  overflow: auto;\n\trow-gap: 5px; // Safari 14.1\n\n\tcolor: var(--app-base);\n\t// font-weight: 500;\n\t// white-space: nowrap;\n\n\t.step {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t// justify-content: center;\n\t\tmax-width: 250px; // HACK\n\t}\n\n\n\t.circle {\n\t\tmargin-right: 8px;\n\n\t\tborder: 1px solid var(--app-base);\n\t\tborder-radius: 50%;\n\n\n\t\theight: 30px;\n\t\tmin-width: 30px;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tpadding-bottom: 1px;\n\n\n\t\t.circle-icon {\n\t\t\tcolor: var(--app-succ);\n\t\t\tfont-size: 20px;\n\t\t}\n\n\t\t&.current {\n\t\t\tbackground-color: var(--app-base);\n\t\t\tcolor: var(--app-main-strong);\n\t\t}\n\n\t\t&.done {\n\t\t\tborder-color: var(--app-succ);\n\t\t\t// border-width: 2px;\n\t\t}\n\n\t}\n\n\n\t.hr {\n\t\tmargin: 0 8px;\n\t\theight: 1px;\n\t\tmin-width: 20px;\n\t\twidth: 40px;\n\t\tbackground-color: var(--app-base);\n\t}\n\n  .hr_piccolo{\n    margin: 0 8px 0 0;\n    height: 1px;\n    min-width: 5px;\n    width: 5px;\n    background-color: var(--app-base);\n  }\n\n\n\t&.compt--main-lg {\n\t\tcolor: var(--app-mid-dark);\n\t\tfont-weight: 500;\n\n\t\t.circle {\n\t\t\tmargin-right: 12px;\n\n\t\t\tborder-color: var(--app-main);\n\t\t\tborder-width: 2px;\n\n\n\t\t\theight: 36px;\n\t\t\tmin-width: 36px;\n\n\t\t\tcolor: var(--app-main);\n\n\n\t\t\t.circle-icon {\n\t\t\t\tfont-size: 24px;\n\t\t\t}\n\n\t\t\t&.current {\n\t\t\t\tbackground-color: var(--app-main);\n\t\t\t\tcolor: var(--app-base);\n\t\t\t}\n\n\t\t\t&.done {\n\t\t\t\tborder-color: var(--app-succ);\n\t\t\t}\n\n\t\t}\n\n\n\t\t.hr {\n\t\t\tmargin: 0 12px;\n\t\t\tbackground-color: var(--app-main);\n\t\t}\n\n\t}\n\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
